export default __webpack_public_path__ + "static/media/userm-1.38a357cc.jpg";